<template>
  <form @submit.prevent="handleSubmit">
    <div class="row">
      <div v-if="checklist_model.account" class="form-group col-sm-12">
          <label for="account_id">Account:</label>
          <input class="form-control" disabled name="account_id" type="text" v-model="checklist_model.account.account_name">
      </div>
      <div class="form-group col-sm-12 required">
          <label for="name">Checklist Model:</label>
          <input class="form-control" required="" name="checklist_model" type="text" v-model="checklist_model.checklist_model">
      </div>
      <div class="form-group col-sm-12 required">
        <label for="name">Code:</label>
        <input class="form-control" required name="code" type="text" v-model="checklist_model.code">
      </div>
      <div class="form-group col-sm-12 required">
        <label for="is_use_vehicle">Use Vehicle:</label>
        <select class="form-control" name="is_use_vehicle" v-model.number="checklist_model.is_use_vehicle">
          <option value="1" style="color:black;">Yes</option>
          <option value="2" style="color:black;">No</option>
        </select>
      </div>
      <div class="form-group col-sm-12 required">
        <label for="status">Status:</label>
        <select class="form-control" name="status" v-model.number="checklist_model.status">
          <option value="1" style="color:black;">Active</option>
          <option value="2" style="color:black;">Inactive</option>
        </select>
      </div>
      <div class="form-group col-sm-12">
        <input class="btn btn-primary" type="submit" value="Save">
        <router-link class="btn btn-default ml-1" to="/checklist_models">Cancel</router-link>
      </div>
    </div>
    <div v-if="this.onRequest" class="modal-backdrop fade show" style="display:flex; align-items: center; justify-content: center;">
      <img :src="require('../assets/loading.gif')"/>
    </div>
  </form>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  export default {
    computed: {
        ...mapState('checklist_models', ['checklist_model', 'onRequest']),
    },
    methods: {
      handleSubmit(){
        if(this.onRequest) return;
        this.edit(this.checklist_model)
      },
      ...mapActions('checklist_models', ['edit', 'get']),
    },
    created() {
      this.$emit('onChildInit', 'Edit Checklist Model')
      this.get(this.$route.params.id)
    }
  }
</script>
